<template>
  <section class="dash-hero" aria-label="Executive overview">
    <div class="dash-hero__glow" aria-hidden="true" />

    <div v-if="$slots.toolbar || periodLabel" class="dash-hero__toolbar">
      <div v-if="$slots.toolbar" class="dash-hero__toolbar-left">
        <slot name="toolbar" />
      </div>
      <span v-if="periodLabel" class="dash-hero__toolbar-meta">
        Reporting · {{ periodLabel }}
      </span>
    </div>

    <div class="dash-hero__grid">
      <div class="dash-hero__copy">
        <p class="dash-hero__eyebrow">AI call agent platform</p>
        <h1 class="dash-hero__title">
          {{ greeting }}, {{ displayName }}
        </h1>
        <p class="dash-hero__subtitle">
          Your AI call agent is actively handling customer conversations.
        </p>
        <div class="dash-hero__status">
          <span class="dash-hero__status-dot" aria-hidden="true" />
          <span>AI systems operational · 24/7 coverage</span>
        </div>
      </div>

      <DashboardAiOrb />
    </div>

    <div class="dash-hero__kpis" role="list">
      <div
        v-for="kpi in kpis"
        :key="kpi.key"
        class="dash-kpi"
        role="listitem"
      >
        <v-icon :icon="kpi.icon" class="dash-kpi__icon" size="18" />
        <div class="dash-kpi__body">
          <span class="dash-kpi__value">{{ kpi.value }}</span>
          <span class="dash-kpi__label">{{ kpi.label }}</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import DashboardAiOrb from '@/components/Dashboard/DashboardAiOrb.vue'

defineOptions({ name: 'DashboardHero' })

defineProps({
  greeting: { type: String, default: 'Good Morning' },
  displayName: { type: String, default: 'there' },
  kpis: { type: Array, default: () => [] },
  periodLabel: { type: String, default: '' },
})

// Deliberately NOT wired to yandle_system_health's live status anymore
// (useSystemHealth composable, still present but unused) -- Ramu, 2026-09-05:
// "we don't want to create a panic situation showing it to the customer."
// A brief/false heartbeat gap (e.g. planned maintenance on the relay it
// depends on) used to flash "Calling system experiencing an outage" on
// every org admin's own dashboard. Internal ops visibility into real
// outages still exists via BMS (left untouched) and the internal email/
// WhatsApp alerts in yandle_system_health -- this is customer-facing only.
</script>
